import { render, staticRenderFns } from "./orderHistory.vue?vue&type=template&id=138842e8&"
import script from "./orderHistory.vue?vue&type=script&lang=ts&"
export * from "./orderHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports